import AppConfig from '../config/app'

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export const validatePassword = (inputValue) => {
  if (!inputValue)
  {
    return 'Nhập mật khẩu';
  }

  if (inputValue.length < AppConfig.Rules.PasswordLength)
  {
    return `Mật khẩu phải >= ${AppConfig.Rules.PasswordLength} kí tự`;
  }

  return false;
}

export const validateActiveAcc = (values) => {
  const error = {}
  
  if (!values.email) {
    error.email = 'Trường bắt buộc'
  }
  else if (!validateEmail(values.email)) {
    error.email = "Email không hợp lệ";
  }

  return error
}
  
export const validateLoginMfa = (values) => {
  const error = {}
  
  if (!values.mfa_code) {
    error.mfa_code = 'Trường bắt buộc'
  }
  else if (values.mfa_code.length != AppConfig.Rules.MFALength)
  {
    error.mfa_code = `Token phải >= ${AppConfig.Rules.MFALength} kí tự`;
  }
  
  return error
}
  
export const validateLogin = (values) => {
  const error = {}

  if (!values.email) {
    error.email = 'Trường bắt buộc'
  }
  else if (values.email.indexOf('@') > -1) {
    if (!validateEmail(values.email)) {
      error.email = "Email không hợp lệ";
    }
  } 

  if (!values.password) {
    error.password = 'Trường bắt buộc'
  }

  return error
}

export const validateResetPassword = (values) => {
  const error = {}

  if (!values.email) {
    error.email = 'Trường bắt buộc'
  }
  else if (!validateEmail(values.email)) {
    error.email = "Email không hợp lệ";
  }
  
  if (!values.new_password) {
    error.new_password = 'Trường bắt buộc'
  }
  else {
    const msg = validatePassword(values.new_password);
    if (msg) {
      error.new_password = msg;
    }
  }
  
  if (!values.new_password_confirm) {
    error.new_password_confirm = 'Trường bắt buộc'
  }
  else if (values.new_password_confirm != values.new_password) {
    error.new_password_confirm = 'Xác nhận mật khẩu không khớp'
  }
    
  return error
}


export const validateRegister = (values) => {
  const error = {}
  if (!values.username) {
    error.username = 'Trường bắt buộc'
  }

  if (!values.fullname) {
    error.fullname = 'Trường bắt buộc'
  }

  if (!values.phone) {
    error.phone = 'Trường bắt buộc'
  }

  if (!values.storename) {
    error.storename = 'Trường bắt buộc'
  }

  if (!values.storeaddress) {
    error.storeaddress = 'Trường bắt buộc'
  }

  if (!values.email) {
    error.email = 'Trường bắt buộc'
  }
  else if (!validateEmail(values.email)) {
    error.email = "Email không hợp lệ";
  }

  if (!values.password) {
    error.password = 'Trường bắt buộc'
  }
  else {
    const msg = validatePassword(values.password);
    if (msg) {
      error.password = msg;
    }
  }

  if (!values.password_confirm) {
    error.password_confirm = 'Trường bắt buộc'
  }
  else if (values.password_confirm != values.password) {
    error.password_confirm = 'Mật khẩu không khớp'
  }
  
  return error
}

export const validateKycSubmit = (values) => {
  const maxFileSize = AppConfig.Rules.MaxKycImageSize || (4*1024*1024);
  const error = {}
  if (!values.fullname) {
    error.fullname = 'Trường bắt buộc'
  }

  if (!values.phone) {
    error.phone = 'Trường bắt buộc'
  }

  if (!values.address) {
    error.address = 'Trường bắt buộc'
  }

  return error
}

export const validate2FARegister = (values) => {
  const error = {}
  
  if (!values.mfa_code) {
    error.mfa_code = 'Trường bắt buộc'
  }
  else if (values.mfa_code.length != AppConfig.Rules.MFALength)
  {
    error.mfa_code = `Token phải >= ${AppConfig.Rules.MFALength} kí tự`;
  }
  
  return error
}

export const validateExchange = (values) => {
  const error = {}
  if (!values.buywith || values.buywith == "") {
    error.buywith = 'Trường bắt buộc'
  }

  if (!values.total || values.total <= 0) {
    error.total = 'Trường bắt buộc'
  }

  if (!values.amount || values.amount <= 0) {
    error.amount = 'Trường bắt buộc'
  }

  return error
}


// WEBPACK FOOTER //
// ./src/lib/validation.js